import React, {Fragment} from "react";
import Card from "../../components/card/Card";
import ModalConfirm from "../../components/ModalConfirm";
import NsDataTable from "../../components/tabelle/NsDataTable";
import {
    getSeverityRuolo,
    getTimestampFormattato
} from "../../utility/common";
import NsButtonActionsGroup from "../../components/buttons/NsButtonActionsGroup";
import NsButtonAction from "../../components/buttons/NsButtonAction";
import {Tag} from "primereact/tag";

export default function ConfUtentiView({
                                           data,
                                           utenteSel,
                                           loadingData,
                                           filtro,
                                           setFiltro,
                                           getUtenti,
                                           translate,
                                           show,
                                           setShow,
                                           eliminaUtente,
                                           optionsRuoli,
                                           pagina,
                                           totPagine,
                                           setPagina,
                                           totUtenti,
                                           orderByCol,
                                           orderByDir,
                                           bottoniDx,
                                           onClickElimina,
                                           onRowDbClickUtente,
                                           onOrderBy,
                                       }) {

    return (
        <Card
            icon={'fas fa-user'}
            title={'Utenti'}
            bottoniDx={bottoniDx}
        >
            <ModalConfirm
                show={show}
                handleClose={() => setShow(false)}
                handleOk={eliminaUtente}
                testo={translate("Sicuro di voler eliminare l'utente: ") + (utenteSel
                    && (utenteSel.nome + ' ' + utenteSel.cognome)) + "?"}/>
            {
                !loadingData &&
                <Fragment>
                    <NsDataTable
                        data={data}
                        columns={[
                            {
                                name: translate('Nome'),
                                selector: row => row.nome,
                                sortable: false,
                                filtroHeader: {
                                    lazy: true,
                                    updateFilter: (val) => {
                                        setFiltro(prevState => ({
                                            ...prevState, ["nome"]: val
                                        }));
                                    },
                                    filter: getUtenti,
                                    startVal: filtro.nome,
                                    dbcol: 'nome'
                                }
                            },
                            {
                                name: translate('Cognome'),
                                selector: row => row.cognome,
                                sortable: false,
                                filtroHeader: {
                                    lazy: true,
                                    updateFilter: (val) => {
                                        setFiltro(prevState => ({
                                            ...prevState, ["cognome"]: val
                                        }));
                                    },
                                    filter: getUtenti,
                                    startVal: filtro.cognome,
                                    dbcol: 'cognome'
                                }
                            },
                            {
                                name: translate('E-mail'),
                                selector: row => row.mail,
                                sortable: false,
                                dbcol: 'mail',
                                sortFunction: (a, b) => {
                                    if (a.mail < b.mail) {
                                        return -1;
                                    }
                                    if (a.mail > b.mail) {
                                        return 1;
                                    }
                                    return 0;
                                },
                                filtroHeader: {
                                    lazy: true,
                                    updateFilter: (val) => {
                                        setFiltro(prevState => ({
                                            ...prevState, ["mail"]: val
                                        }));
                                    },
                                    filter: getUtenti,
                                    startVal: filtro.mail
                                }
                            },
                            {
                                name: translate('Ruolo'),
                                selector: row => <Tag className="mr-2" severity={getSeverityRuolo(row.ruolo, optionsRuoli)} value={row.ruolo}/>,
                                sortable: true,
                                sortFunction: (a, b) => {
                                    return a.ruolo < b.ruolo;
                                },
                                dbcol: 'ruolo',
                                filtroHeader: {
                                    lazy: true,
                                    updateFilter: (val) => {
                                        setFiltro(prevState => ({
                                            ...prevState, ["id_ruolo"]: val
                                        }));
                                    },
                                    startVal: filtro.id_ruolo,
                                    filterOptions: optionsRuoli ? optionsRuoli.map((r) => ({
                                        id: r.id_ruolo,
                                        descrizione: r.nome
                                    })) : [],
                                    statusItemTemplate: (option) => {
                                        return <Tag className="mr-2" severity={getSeverityRuolo(option, optionsRuoli)} value={option}/>
                                    }
                                }
                            },
                            {
                                name: translate('Data registrazione'),
                                selector: row => getTimestampFormattato(row.registrazione),
                                sortable: true,
                                dbcol: 'registrazione',
                                filtroHeader: {
                                    lazy: true,
                                    updateFilter: (val) => {
                                        setFiltro(prevState => ({
                                            ...prevState, ["registrazione"]: val
                                        }));
                                    },
                                    type: 'datepicker',
                                    startVal: filtro.registrazione
                                }
                            },
                            {
                                name: translate('Attivo'),
                                selector: row => row.attivo && parseInt(row.attivo) === 1 ?
                                    <Tag className="mr-2" icon="fas fa-user-check" severity="success" value={translate("Attivo")}/>
                                    :
                                    <Tag className="mr-2" icon="fas fa-user-times" severity="danger" value={translate("Non attivo")}/>,
                                sortable: true,
                                dbcol: 'attivo',
                                sortFunction: (a, b) => {
                                    return a.attivo - b.attivo;
                                },
                                filtroHeader: {
                                    lazy: true,
                                    updateFilter: (val) => {
                                        setFiltro(prevState => ({
                                            ...prevState, ["attivo"]: val
                                        }));
                                    },
                                    startVal: filtro.attivo,
                                    filterOptions: [
                                        {
                                            id: '0',
                                            descrizione: translate("Non attivo")
                                        },
                                        {
                                            id: '1',
                                            descrizione: translate("Attivo")
                                        }],
                                    statusItemTemplate: (option) => {
                                        if (option == translate("Attivo")) {
                                            return <Tag className="mr-2" icon="fas fa-user-check" severity="success" value={translate("Attivo")}/>
                                        } else {
                                            return <Tag className="mr-2" icon="fas fa-user-times" severity="danger" value={translate("Non attivo")}/>
                                        }
                                    }
                                }
                            },
                            {
                                name: '',
                                selector: row => <NsButtonActionsGroup>
                                    <li>
                                        <NsButtonAction
                                            label={"Modifica"}
                                            icona={"fas fa-pen"}
                                            href={"/upd-utente/" + row.id_utente}
                                        />
                                    </li>
                                    <li>
                                        <NsButtonAction
                                            label={"Elimina"}
                                            disabled={parseInt(row.is_default) === 1}
                                            icona={"fas fa-trash"}
                                            onClick={() => {
                                                onClickElimina(row);
                                            }}
                                        />
                                    </li>
                                </NsButtonActionsGroup>,
                                sortable: false,
                                right: true,
                            }
                        ]}
                        pagina={pagina}
                        totalePagine={totPagine}
                        handlerCambioPagina={setPagina}
                        totRighe={totUtenti}
                        addPagination={false}
                        addFiltri={false}
                        onRowDbClick={onRowDbClickUtente}
                        orderBy={onOrderBy}
                        orderByColonna={orderByCol}
                        orderByDirezione={orderByDir}
                    />
                </Fragment>
            }
        </Card>
    );
}
